import { withStyles } from '@material-ui/core';

const styles = () => ({
  divider: {
    width: '100%',
  },
});
export default withStyles(styles);
